export class NotificationUnreadCountsView {
    newSuppliers: number;
    blocked: number;
    capped: number;
    holidays: number;
    mailingPlannings: number;
    /** The badge itself: the sum of the five groups. */
    total: number;
    unpaid: number;

    constructor(data?: any) {
        this.newSuppliers = data?.newSuppliers ?? 0;
        this.blocked = data?.blocked ?? 0;
        this.capped = data?.capped ?? 0;
        this.holidays = data?.holidays ?? 0;
        this.mailingPlannings = data?.mailingPlannings ?? 0;
        this.total = data?.total ?? 0;
        this.unpaid = data?.unpaid ?? 0;
    }
}
